interface GameItemPromptProps {
  label: string
  name: string
  description?: string | null
}

export function GameItemPrompt({
  label,
  name,
  description,
}: GameItemPromptProps) {
  return (
    <div
      data-game-item-prompt="true"
      className="mx-auto mb-4 w-fit max-w-full rounded-2xl border border-white/20 px-4 py-3 text-center shadow-[0_12px_32px_rgba(0,0,0,0.42)] backdrop-blur-md sm:px-5"
      style={{ backgroundColor: "rgba(9, 9, 11, 0.72)", color: "#fff" }}
    >
      <div className="mb-2 text-xs font-bold uppercase tracking-[0.18em] text-white drop-shadow-[0_2px_6px_rgba(0,0,0,0.9)]">
        {label}
      </div>
      <h2 className="text-balance text-2xl font-bold text-white drop-shadow-[0_3px_10px_rgba(0,0,0,0.95)] md:text-4xl">
        {name}
      </h2>
      {description && (
        <p className="mt-2 text-sm font-medium text-white drop-shadow-[0_2px_8px_rgba(0,0,0,0.95)] md:text-base">
          {description}
        </p>
      )}
    </div>
  )
}
